import { VSelect } from "vuetify/lib";

export default VSelect.extend({
  name: "select-acessivel",
  mounted() {
    this.$watch(() => this.$refs.menu && this.$refs.menu.listIndex, this.marcarOpcaoAtiva);
  },
  methods: {
    genInput() {
      const input = VSelect.options.methods.genInput.call(this);
      const selecionado = this.selectedItems.map(this.getText).join(", ");

      input.data.attrs = {
        ...input.data.attrs,
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-expanded": String(this.isMenuActive),
        "aria-controls": this.computedOwns,
        "aria-label": this.label && selecionado ? `${this.label}, ${selecionado}` : undefined,
      };
      return input;
    },
    genInputSlot() {
      const slot = VSelect.options.methods.genInputSlot.call(this);
      const attrs = { ...slot.data.attrs };

      ["role", "aria-haspopup", "aria-expanded", "aria-owns"].forEach((nome) => delete attrs[nome]);
      slot.data.attrs = attrs;
      return slot;
    },
    onMenuActiveChange(aberto) {
      VSelect.options.methods.onMenuActiveChange.call(this, aberto);
      if (!aberto || this.getMenuIndex() > -1) return;

      this.$nextTick(() => {
        this.$refs.menu.getTiles();
        this.setMenuIndex(0);
      });
    },
    marcarOpcaoAtiva(indice) {
      const campo = this.$refs.input;
      const opcao = this.$refs.menu && this.$refs.menu.tiles[indice];
      if (!campo) return;

      if (opcao && opcao.id) campo.setAttribute("aria-activedescendant", opcao.id);
      else campo.removeAttribute("aria-activedescendant");
    },
  },
});
